import React from 'react'
import { Link } from 'react-feather'

const NoDataHandler = ({ title,height='100vh' }) => {
    return (
        <div style={{ width: '100%', height: height, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div>
                {title}
                <div style={{ marginTop: '20px' }}>
                    {/* <Link to="/add-product" className="btn btn-primary">Add Product</Link> */}
                </div>
            </div>
        </div>
    )
}

export default NoDataHandler
